module.exports = __webpack_public_path__ + "static/img/helh323.d93f410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh323.png
// module id = RUop
// module chunks = 5